import { QueueSpacing, StackSpacing } from "app/shared/components/spacing";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { View, StyleSheet, Pressable } from "react-native";
import { Dialog, Paragraph, useTheme } from "react-native-paper";
import { ModalProps } from "../reducer/types";

const ModalUpdate = ({ closeModal, acceptModal, title, message, content, titleBtnAccept, titleBtnCancel, onClickClose }: ModalProps) => {
  const { t } = useTranslation();
  const { colors, fonts } = useTheme();
  const accentColorStyle = { color: colors.accent };
  const cancelColorStyle = { color: colors.placeholder };
  const buttonStyle = { ...fonts.bold };

  const onClickAccept = () => {
    if (closeModal) closeModal(true);
    if (acceptModal) acceptModal();
  };

  const onClickCloseModal = () => {
    if (closeModal) closeModal(false);
    if (onClickClose) onClickClose();
  };

  return (
    <View style={styles.container}>
      <Dialog.Title children={title || t("COMMON_THONG_BAO")} style={[accentColorStyle, styles.titleStyle]} />
      <Dialog.Content children={content ? content : <Paragraph style={styles.messageStyle} children={message} />} />
      <Dialog.Actions style={styles.actionStyle}>
        <Pressable onPress={onClickAccept}>
          <Paragraph style={[accentColorStyle, buttonStyle]} children={titleBtnAccept?.length ? titleBtnAccept : t("COMMON_DONG_Y")} />
        </Pressable>
        <StackSpacing size="small" />
        {titleBtnCancel ? (
          <Pressable onPress={onClickCloseModal}>
            <Paragraph style={[cancelColorStyle, buttonStyle]} children={titleBtnCancel?.length ? titleBtnCancel : t("COMMON_DONG")} />
          </Pressable>
        ) : null}
      </Dialog.Actions>
    </View>
  );
};

export default ModalUpdate;

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  titleStyle: {
    letterSpacing: 0,
    textAlign: "center",
  },
  textStyle: {
    textAlign: "center",
  },
  messageStyle: {
    color: "black",
    letterSpacing: 0,
    textAlign: "center",
  },
  actionStyle: {
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
});
